import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  // Bố cục 2 phần: hàng trên (ảnh tiêu biểu, kích cỡ to) + hàng dưới (ảnh còn lại, nhỏ hơn).
  gallery: {
    display: "flex",
    flexDirection: "column",
    gap: 28,
  },
  rowTitle: {
    fontWeight: 700,
    color: "#ee6064",
    marginBottom: 10,
    fontSize: 18,
  },

  // Khung marquee tự chạy (auto slideshow). Di chuột vào để tạm dừng.
  marquee: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    "&:hover $track": { animationPlayState: "paused" },
  },
  track: {
    display: "flex",
    width: "max-content",
    animationName: "$marquee",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
  },
  "@keyframes marquee": {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-50%)" },
  },

  item: {
    position: "relative",
    flex: "0 0 auto",
    borderRadius: 12,
    overflow: "hidden",
    cursor: "pointer",
    marginRight: 16,
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
    },
    "&:hover $image": { transform: "scale(1.06)" },
    "&:hover $overlay": { opacity: 1 },
  },
  // Hàng trên: ảnh to.
  itemLarge: {
    width: 620,
    [theme.breakpoints.down("sm")]: { width: 460 },
    [theme.breakpoints.down("xs")]: { width: 320 },
  },
  imageLarge: {
    height: 420,
    [theme.breakpoints.down("sm")]: { height: 300 },
    [theme.breakpoints.down("xs")]: { height: 220 },
  },
  // Hàng dưới: ảnh nhỏ hơn.
  itemSmall: {
    width: 340,
    [theme.breakpoints.down("xs")]: { width: 250 },
  },
  imageSmall: {
    height: 230,
    [theme.breakpoints.down("xs")]: { height: 170 },
  },
  image: {
    width: "100%",
    objectFit: "cover",
    display: "block",
    transition: "transform 0.4s ease",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    padding: 12,
    opacity: 0,
    background:
      "linear-gradient(to top, rgba(238,96,100,0.55) 0%, rgba(0,0,0,0) 55%)",
    transition: "opacity 0.25s ease",
  },
  zoomHint: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 0.3,
    textShadow: "0 1px 4px rgba(0,0,0,0.5)",
  },

  // Lightbox
  lightboxPaper: {
    position: "relative",
    backgroundColor: "rgba(18,18,18,0.96)",
    overflow: "hidden",
    margin: 16,
  },
  lightboxContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  lightboxImage: {
    maxWidth: "90vw",
    maxHeight: "80vh",
    objectFit: "contain",
    display: "block",
  },
  lightboxFooter: {
    width: "100%",
    textAlign: "center",
    padding: "10px 48px",
    color: "#eee",
  },
  counter: { color: "#bdbdbd" },
  caption: { color: "#fff", marginTop: 2 },
  closeBtn: {
    position: "absolute",
    top: 6,
    right: 6,
    zIndex: 2,
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.35)",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
  },
  navBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.35)",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
  },
  navPrev: { left: 8 },
  navNext: { right: 8 },
}));
